import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import {
  IMG_CASH_PICKUP_FORCE_GUIDE_03,
  IMG_CASH_PICKUP_GUIDE_MAIN,
} from '@repo/assets';
import styled from 'styled-components';
import { CashPickupIntroBox } from '@repo/components';
import { useEffect } from 'react';
import TextButton from '@/components/common/TextButton';
import { useHistory, useLocation } from 'react-router';
import { routes } from '@/constants/routes.const';
import { useMutation } from 'react-query';
import { postExecuteAirport } from '@/api';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import {
  CASH_PICKUP_FORCE_REFUND_CRUISE,
  CASH_PICKUP_FORCE_REFUND_PROCESS_BOXES,
  CASH_PICKUP_STORE_INTRO_BOXES,
  FORCE_REFUND_PROCESS_BOXES,
} from '@/constants/guide.const';

export default function CashPickupIntro() {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const from = searchParams.get('from');
  const { passportNumber, departureDate, isUploadRequired } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const isCruise =
    passportNumber && localStorage.getItem(passportNumber) === 'Cruise';

  const { mutate: executeAirport } = useMutation(
    () => postExecuteAirport(passportNumber!),
    {
      onSuccess: () => {
        history.replace(routes.home);
      },
      onError: (error) => {
        // 에러 알림 모달
        console.error('Error executing airport:', error);
        alert('Failed to execute airport action. Please try again.');
        if (departureDate) {
          history.push(routes.home);
        } else {
          history.push('/departure');
        }
      },
      retry: false,
    },
  );
  useEffect(() => {
    const handleBackButton = () => {
      window.history.go(1);
    };
    window.addEventListener('popstate', handleBackButton);
    return () => window.removeEventListener('popstate', handleBackButton);
  }, []);

  const handleNavigateHome = () => {
    if (from === 'home') {
      history.replace(routes.home);
      return;
    }
    executeAirport();
  };

  return (
    <ReceiptLayout hasPadding={false}>
      <MainImage
        src={IMG_CASH_PICKUP_GUIDE_MAIN}
        alt='CashPickupGuideMainImage'
      />
      <InnerWrapper>
        <Title>
          Receive Your Cash Directly at Western Union Without a Bank Account
        </Title>
        <BoxWrapper>
          {isUploadRequired &&
            isCruise &&
            CASH_PICKUP_FORCE_REFUND_CRUISE.map((box) => (
              <CashPickupIntroBox key={box.index} {...box} />
            ))}
          {isUploadRequired &&
            !isCruise &&
            CASH_PICKUP_FORCE_REFUND_PROCESS_BOXES.map((box) => (
              <CashPickupIntroBox key={box.index} {...box} />
            ))}
          {!isUploadRequired &&
            CASH_PICKUP_STORE_INTRO_BOXES.map((box) => (
              <CashPickupIntroBox key={box.index} {...box} />
            ))}
        </BoxWrapper>
        <BtnWrapper>
          <TextButton
            title='Go to get Tax Refund'
            onClick={handleNavigateHome}
          />
        </BtnWrapper>
      </InnerWrapper>
    </ReceiptLayout>
  );
}

const Title = styled.h1`
  color: var(--KTP-Grayscale-Gray_02, #111);
  font-size: 24px;
  font-weight: 700;
  line-height: 150%; /* 36px */
  letter-spacing: -0.48px;
`;

const MainImage = styled.img`
  width: 100%;
  height: auto;
`;

const InnerWrapper = styled.div`
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const BoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
`;

const BtnWrapper = styled.div``;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f4f4f4;
  margin: -36px 0;
`;
